import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetCorporate } from '../../reducers/customerCorporateReducer';
import AddCorporateForm from './addCorporateForm';
import { FormType } from '../../constants/constants';

interface IAddCorporateProps {
    classes: any;
    theme: Theme;
    match: any;
    resetCorporate: any;
    steps: Array<number>;
    corporateId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetCorporate: () => dispatch(resetCorporate())
});

const mapStoreToProps = (store: RootState, ownProps: IAddCorporateProps) => {
    return {
        corporateId: ownProps.match.params?.corporateId ? Number(ownProps.match.params?.corporateId) : undefined
    };
};

class AddCorporate extends Component<IAddCorporateProps> {
    componentWillUnmount() {
        const { resetCorporate } = this.props;

        resetCorporate();
    }

    render() {
        const { classes, steps, corporateId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <AddCorporateForm corporateId={corporateId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddCorporate));